import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4LandlordRequiredArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'Is HO-4 Required by My Landlord? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', 'Learn when landlords require HO-4 renters insurance and what lease requirements to check before move-in.');
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/is-ho4-required-by-landlord"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>Is HO-4 required by my landlord?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>Many leases require renters insurance, often with a minimum liability amount.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4"><div className="card-body">
            <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
            <p>Not every landlord requires HO-4, but many apartment communities do. Always check your lease for minimum liability requirements, proof-of-insurance rules, and interested-party details.</p>
            <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>What to verify in your lease</h3>
            <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>Minimum liability limit.</li>
              <li style={{ marginBottom: '0.5rem' }}>Coverage start date (often before key pickup).</li>
              <li style={{ marginBottom: '0.5rem' }}>Interested party / additional interest details.</li>
              <li>Any special required endorsements.</li>
            </ul>
            <p style={{ marginTop: '1rem', marginBottom: 0 }}>
              If your lease sets a minimum, compare options in <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>how much liability you may need</Link> and then follow <Link to="/knowledge-base/how-to-get-ho4-renters-insurance" style={articleLinkStyle}>how to get HO-4</Link>.
            </p>
          </div></article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Start your HO-4 flow and match your lease requirements fast.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help with lease requirements?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can help verify required limits and get your policy set correctly.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4LandlordRequiredArticlePage;

